
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
    @Prop({default:false}) private show!: any;
    @Prop({ default: '暂无数据' }) private msg!: string;
    @Prop({default:'25%'}) private imgSize!:string;
}
